import React, { useState } from "react";

const RadioGroupV2 = ({ name, onBlur, field, value, setFieldValue, options }) => {
    const [selectedValue, setSelectedValue] = useState(value);

    const handleRadioChange = (value) => {
        setSelectedValue(value);
        setFieldValue(field, value);
    };

    return (
        <fieldset id={name} onBlur={onBlur}>
            <div className="radio-group-container">
                {options.map((option) => (
                    <>
                        <input
                            className="radio-input"
                            type="radio"
                            key={option.value}
                            id={option.value}
                            value={option.value}
                            text={option.label}
                            checked={selectedValue === option.value}
                            onClick={() => handleRadioChange(option.value)}
                            containerClasses={value === option.value ? "active" : ""}
                        />
                        <label
                            htmlFor={option.value}
                            className={`radio-label ${value === option.value ? "bold-label" : ""}`}
                        >
                            {option?.label}
                        </label>
                    </>
                ))}
            </div>
        </fieldset>
    );
};

export default RadioGroupV2;
